"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeTextInput = void 0;
const react_1 = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const material_1 = require("@mui/material");
const Search_1 = __importDefault(require("@kyruus/react-ikons/Search"));
const ErrorCircleOutline_1 = __importDefault(require("@kyruus/react-ikons/ErrorCircleOutline"));
const loaders_and_spinners_1 = require("@kyruus/loaders-and-spinners");
const ui_theme_1 = require("@kyruus/ui-theme");
const util_1 = require("./util");
const FreeTextPoppper_1 = require("./FreeTextPoppper");
const FreeTextGroup_1 = require("./FreeTextGroup");
const states_1 = require("../../../lib/xstate/states");
const AutocompleteComponent = (0, ui_theme_1.withMuiThemeAdapter)(material_1.Autocomplete);
const StyledSpinnerContainer = styled_1.default.div `
  opacity: ${(props) => (props.fetching ? '1' : '0')};
`;
const FreeTextInput = ({ id = (0, util_1.uuid)(), autoComplete, searchLabelTemplate, searchInputTemplate, displayDictionary, value = '', suggestions = [], noScrollDropdownResults, onChange, onInputFocus, onSelect, onOpen, onClose, state }) => {
    const [selectedCategory, selectCategory] = react_1.default.useState('All');
    const { config } = state.context;
    const label = displayDictionary['free_text.label'];
    const placeholder = displayDictionary['free_text.placeholder'];
    const noSuggestions = displayDictionary['free_text.no_suggestions'];
    const ariaLabel = displayDictionary['free_text.aria_label'];
    const ariaLabelWithSuggestions = displayDictionary['free_text.aria_label_with_suggestions'];
    const open = state.matches(states_1.States.TYPEAHEAD_OPEN) ||
        state.matches(states_1.States.NO_RESULTS) ||
        state.matches(`${states_1.States.PREVIEW}.typeahead.${states_1.States.TYPEAHEAD_OPEN}`);
    const hasError = state.matches(`${states_1.States.EMPTY_SEARCH_ERROR}`) ||
        state.matches(`${states_1.States.PREVIEW}.error.${states_1.States.EMPTY_SEARCH_ERROR}`);
    const hasSuggestions = suggestions.length > 0;
    const fetching = state.matches(states_1.States.FETCHING_TYPEAHEAD_SUGGESTIONS);
    const inNoResultsState = state.matches(states_1.States.NO_RESULTS);
    const StyledListItem = (0, react_1.useMemo)(() => (0, styled_1.default)('div')(autoComplete.listItem), []);
    const StyledLabel = (0, react_1.useMemo)(() => (0, styled_1.default)('label')(searchLabelTemplate), []);
    const StyledInput = (0, react_1.useMemo)(() => (0, styled_1.default)('div')(searchInputTemplate), []);
    // get all the categories in the suggestion data, and dedupe them
    const categories = (0, react_1.useMemo)(() => Array.from(new Set(suggestions.map((suggestion) => suggestion.categoryDisplayText))), [suggestions]);
    const filteredSuggestions = selectedCategory !== 'All'
        ? suggestions.filter(({ categoryDisplayText }) => categoryDisplayText === selectedCategory)
        : suggestions;
    const groupByProp = (config === null || config === void 0 ? void 0 : config.params.group_suggestions_by_category)
        ? (option) => option.categoryDisplayText
        : undefined;
    // dummy suggestion to maintain parity with older versions of MUI. As of MUI 5, the "No options"
    // state won't actually render when the options list is empty, so we populate it with a single
    // dummy suggestion when inNoResultsState to force the empty results message to appear
    const emptySuggestion = {
        highlight: '',
        name: '',
        category: 'clinical_keywords',
        categoryDisplayText: '',
        queryString: '',
        score: 0
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (0, util_1.shouldShowLabel)(label) && (react_1.default.createElement(StyledLabel, { htmlFor: id, "data-testid": "sw-label", "data-ref": "label-search", id: `${id}-label` }, label)),
        react_1.default.createElement(StyledInput, null,
            react_1.default.createElement(AutocompleteComponent, { freeSolo: true, autoComplete: true, value: value, id: id, onOpen: onOpen, onClose: onClose, open: open, onChange: onSelect, blurOnSelect: true, onInputChange: (event, newInputValue) => {
                    // Because `onInputchange` fires when `onChange` fires,
                    // we want to only trigger this on `change` and not on `click`
                    // which would be the `selection` of an option
                    // https://github.com/mui-org/material-ui/issues/18784
                    if (event && event.type === 'change') {
                        onChange(event, newInputValue);
                    }
                }, options: inNoResultsState ? [emptySuggestion] : filteredSuggestions, groupBy: groupByProp, renderGroup: (props) => (react_1.default.createElement(FreeTextGroup_1.FreeTextGroup, Object.assign({ autoComplete: autoComplete }, props))), filterOptions: (options) => {
                    // do not filter the options, just return them
                    return options;
                }, PopperComponent: (props) => (react_1.default.createElement(FreeTextPoppper_1.FreeTextPopper, Object.assign({ categories: categories, autoComplete: autoComplete, selectedCategory: selectedCategory, selectCategory: (name) => selectCategory(name), style: props.style, getPopupElem: () => document.getElementById(`${id}-popup`), inNoResultsState: inNoResultsState, renderNoSuggestions: () => 
                    // NOTE: we're following the same renderinng
                    // format as in `renderOption` to keep the styling consistent
                    inNoResultsState && (react_1.default.createElement("ul", { "data-testid": "sw-no-results" },
                        react_1.default.createElement("li", null,
                            react_1.default.createElement(StyledListItem, null,
                                react_1.default.createElement(ErrorCircleOutline_1.default, { size: "18px" }),
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement("span", null, noSuggestions)))))), 
                    // handles sizing the dropdown such that all results are visible without element inner scroll
                    noScrollDropdownResults: noScrollDropdownResults }, props))), renderInput: (params) => {
                    var _a, _b, _c, _d;
                    return (react_1.default.createElement("div", { ref: params.InputProps.ref, className: "sw-input-container" },
                        react_1.default.createElement("input", Object.assign({ "data-ref": "input-search", "data-testid": "sw-text-input", "aria-required": !((_a = state.context.config) === null || _a === void 0 ? void 0 : _a.params.allow_empty_search), type: "text", name: "searchTerm", "data-error": hasError, "aria-invalid": state.matches(`${states_1.States.EMPTY_SEARCH_ERROR}`), 
                            // complains about missing aria tags that material UI adds after it mounts
                            // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
                            role: "combobox", "aria-expanded": open, "aria-label": hasSuggestions ? ariaLabelWithSuggestions : ariaLabel, "aria-describedby": hasError ? 'sw-empty-search-error' : undefined, placeholder: placeholder }, params.inputProps, { 
                            // NOTE: jsx-a11y/no-autofocus
                            // autoFocus is bad for accessiblity because it can cause the page
                            // to scroll on load. Since we enable it using a config, the user
                            // can choose to not set this on if the widget is below the fold
                            /*eslint-disable-next-line*/
                            autoFocus: (_d = (_c = (_b = state.context.config) === null || _b === void 0 ? void 0 : _b.params) === null || _c === void 0 ? void 0 : _c.focus_on_widget) !== null && _d !== void 0 ? _d : false, onFocus: onInputFocus })),
                        react_1.default.createElement(StyledSpinnerContainer, { fetching: fetching, className: "sw-spinner-container" },
                            react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, null))));
                }, getOptionLabel: (a) => (typeof a === 'string' ? a : a.name), renderOption: (props, option) => (react_1.default.createElement("li", Object.assign({}, props),
                    react_1.default.createElement(StyledListItem, { "data-testid": "sw-suggestion", "data-ref": "suggestion-option" },
                        react_1.default.createElement(Search_1.default, null),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("span", { dangerouslySetInnerHTML: {
                                    __html: option.highlight ? option.highlight : option.name
                                } }))))) }))));
};
exports.FreeTextInput = FreeTextInput;
//# sourceMappingURL=FreeTextInput.js.map